/** @format */

import { Component, Input, HostBinding, ViewChild, inject } from '@angular/core';

import { ModalController, IonContent, IonFooter } from '@ionic/angular/standalone';
import { ListTitleComponent } from '../list-title/list-title.component';

@Component({
    selector: 'fs-base-modal',
    templateUrl: './base-modal.component.html',
    styleUrls: ['./base-modal.component.scss'],
    standalone: true,
    imports: [ListTitleComponent, IonContent, IonFooter]
})
export class BaseModalComponent {
  private modalCtrl = inject(ModalController);

  @Input() title: string;
  @Input() description: string;
  @Input() titleIcon: string;
  @Input() mode: 'light' | 'dark' = 'dark';
  @HostBinding('attr.ngNoHost') noHost = '';
  @ViewChild(IonContent, { read: IonContent, static: false }) content: IonContent;

  dismiss(event = {}) {
    this.modalCtrl.dismiss(event);
  }

  scrollToTop() {
    this.content.scrollToTop(400);
  }
}
